export const clsPrefix = 'ebdpage';

/**
 * 页面运行类前缀
 */
export const pageViewClsPrefix = 'weapp-ebpv';

/**
 * 移动端页面运行类前缀
 */
export const mPageViewClsPrefix = 'weapp-mpv';

export const ebcomPrefix = 'ebcom';

/**
 * 应用名称，用于组件注入middleware传值
 */
export const appName = 'weappEBpage';

export enum ErrorType {
  NoPage = 'noPage',
  NoData = 'NoData',
  NoPermission = 'noPermission',
}

export enum LayoutType {
  /** 自由布局 */
  GridLayout = 'GRID',
  /** 流式布局 */
  FlowLayout = 'FLOW',
}

/** 组件显示隐藏 */
export enum Display {
  None = 1,
  Block = 2,
}

/**
 * 性能优化：ebdcoms不阻塞页面请求的发出
 * 此处冗余ebdcoms里面的PageModuleType
 */
export enum PageModuleType {
  Eb = 'EB_PAGE',
  Portal = 'PORTAL_PAGE',
  EbForm = 'EB_FORM_VIEW',
  Scene = 'SCENE',
  Synergy = 'SYNERGY',
  LoginPage = 'LOGIN_PAGE',
  ThemePage = 'THEME_PAGE',
  BI = 'BI',
}

// 固定菜单
export const FixedMenu = {
  Base: 'BASE',
  Recycle: 'RECYCLE', // 回收站
  Setting: 'SETTING',
};

export enum FixedPageId {
  AccessLog = 'ACCESSLOG',
}

// 应用构建支持
export const BuildLib = {
  Template: 'CONTRACTTEMPLATE', // 模板库
  Clause: 'CONTRACTBOX', // 条款库
};

// 多级填报
export const MultiFill = {
  FillingTask: 'FILLINGTASK',
  TaskMonitoring: 'TASKMONITORING',
  MultireportMonitor: 'MULTIREPORTMONITOR',
  MultireportTask: 'MULTIREPORTTASK',
};

/** 系统菜单类型 */
export const SystemMenu = {
  /** 标准-流程 */
  CusWorkFlow: 'CUS_WORKFLOW',
  /** 表单 */
  FormDataReport: 'FORMDATAREPORT',
  /** 审批统计 */
  WorkFlowStatistic: 'WORKFLOWSTATISTIC',
  /** 项目 */
  Project: 'PROJECT',
  /** 文件夹 */
  Folder: 'FOLDER',
  /** 集成登录 */
  Intelement: 'INTELEMENT',
  /** 审批中心 */
  WorkFlowList: 'WORKFLOW_LIST',
  /** 标准菜单 */
  System: 'SYSTEM',
};

/** 系统菜单类型列表 */
export const SystemMenuList = [
  SystemMenu.System,
  SystemMenu.CusWorkFlow,
  SystemMenu.FormDataReport,
  SystemMenu.WorkFlowList,
  SystemMenu.Project,
  SystemMenu.Folder,
  SystemMenu.Intelement,
  SystemMenu.WorkFlowStatistic,
];

// 以下组件在无权限时始终不显示
export const gridPcHiddenComs = ['HelpTip'];

export const gridMobileHiddenComs = ['FloatButton'];

export const flowPcHiddenComs = ['HelpTip', 'Picture', 'EbButton', 'QrAndBarCode'];

export const flowMobileHiddenComs = ['HelpTip', 'Picture', 'EbButton', 'FloatButton'];

const primaryColor = window.TEAMS?.theme?.primaryColor || '#4ba9f2';

export const DEFAULT_APP_ICON_PATH = JSON.stringify({
  path: '#icon-eBuilder-o',
  style: {
    color: primaryColor,
    fillType: 'borderColor',
    borderColor: primaryColor,
    fontSize: 28,
    radius: '2px',
  },
});

/**
 * 需要阻挡的 路由path
 */
export const BlockPathList = [
  /** 流程 */
  'workflow',
];

/** 内置的容器组件类型名称 */
export const INTERNAL_CONTAINER = 'InternalContainer';

export enum EventsType {
  Click = 'CLICK' /** 单击事件 */,
  ClickData = 'CLICKDATA' /** 单击每一条数据事件 */,
  DidMount = 'DIDMOUNT' /** 载入 */,
  PressEnter = 'PRESSENTER' /** 回车事件 */,
  MouseEnterData = 'MOUSEENTERDATA' /** 鼠标移入每一条数据事件 */,
  MouseLeaveData = 'MOUSELEAVEDATA' /** 鼠标移出每一条数据事件 */,
}

/** 弹窗组件的key */
export const dialogKey = 'dlg/';

/* 路由根路径 */
export const root = window.publicUrlweappUi || window.publicUrlstatic || window.publicUrl || '';

export default {};
